import { render, staticRenderFns } from "./model-sale.vue?vue&type=template&id=5c324138&scoped=true"
import script from "./model-sale.vue?vue&type=script&lang=ts"
export * from "./model-sale.vue?vue&type=script&lang=ts"
import style0 from "./model-sale.vue?vue&type=style&index=0&id=5c324138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c324138",
  null
  
)

export default component.exports